import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {WPFactSection} from '../../typings/WPFactSection';
import {FactsLabelsEnum} from '../../enums/facts-labels.enum';

@Component({
  selector: 'app-search-content-facts-v2',
  templateUrl: './search-content-facts-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentFactsV2Component {
  public factsSections = input<Array<WPFactSection>>([]);
  public title = input<string>();
  public factsFirstSection = computed<Array<WPFactSection>>(() =>
    this.factsSections()
      ? this.factsSections()
          .filter(
            (item) =>
              item.label.value !== FactsLabelsEnum.VIKTIGA_LANKAR &&
              item.label.value !== FactsLabelsEnum.VIKTIGA_TELEFONNUMMER,
          )
          .map((item) => {
            let tmpItem = Object.assign({}, item);
            tmpItem.label.label =
              tmpItem.label.value === FactsLabelsEnum.CUSTOM ? tmpItem.customLabel : tmpItem.label.label;
            return tmpItem;
          })
      : [],
  );
  public factsSecondSection = computed<Array<WPFactSection>>(() =>
    this.factsSections()
      ? this.factsSections()
          .filter(
            (item) =>
              item.label.value === FactsLabelsEnum.VIKTIGA_LANKAR ||
              item.label.value === FactsLabelsEnum.VIKTIGA_TELEFONNUMMER,
          )
          .map((item) => {
            let tmpItem = Object.assign({}, item);
            tmpItem.label.label =
              tmpItem.label.value === FactsLabelsEnum.CUSTOM ? tmpItem.customLabel : tmpItem.label.label;
            return tmpItem;
          })
      : [],
  );
}
